module.exports = __webpack_public_path__ + "static/img/meizhilu.a73061c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/meizhilu.png
// module id = 4MEF
// module chunks = 1